import React from 'react';
import { Trans } from 'react-i18next';
import ButtonAdd from 'components/ButtonAdd';
import { ROUTE } from 'constants/route';
import { RIGHTS } from 'constants/rights';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.PRESENTATION_TYPE_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.PRESENTATION_TYPE.ADD}
  >
    <Trans>PRESENTATION_TYPE.NEW</Trans>
  </ButtonAdd>
);

export default Actions;
